var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("el-collapse-transition", [
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.show,
            expression: "show",
          },
        ],
      },
      [
        _c(
          "el-row",
          { attrs: { gutter: 60 } },
          [
            _c(
              "el-col",
              { attrs: { span: 8 } },
              [
                _c(
                  "el-form-item",
                  {
                    key:
                      "customerTireBizYear_" + (_vm.isBailianFlag ? "by" : ""),
                    staticClass: "form-item-title",
                    attrs: {
                      prop: "customerTireBizYear",
                      rules: _vm.isBailianFlag ? _vm.rules.iptEmpty : null,
                      label: _vm.$t(
                        "retailStoresInfo.form.storeArchSit.experienceYear"
                      ),
                    },
                  },
                  [
                    _c("FormInputNumber", {
                      attrs: {
                        val: _vm.form.customerTireBizYear,
                        maxlength: 4,
                        mode: _vm.type,
                      },
                      on: {
                        "update:val": function ($event) {
                          return _vm.$set(
                            _vm.form,
                            "customerTireBizYear",
                            $event
                          )
                        },
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "el-col",
              { attrs: { span: 8 } },
              [
                _c(
                  "el-form-item",
                  {
                    key: "customerTireSob_" + (_vm.isBailianFlag ? "by" : ""),
                    attrs: {
                      label: _vm.$t(
                        "retailStoresInfo.form.storeArchSit.businessVolume"
                      ),
                      prop: "customerTireSob",
                      rules: _vm.isBailianFlag ? _vm.rules.iptEmpty : null,
                    },
                  },
                  [
                    _c(
                      "FormInputNumber",
                      {
                        attrs: {
                          val: _vm.form.customerTireSob,
                          max: 100,
                          step: 0.01,
                          mode: _vm.type,
                        },
                        on: {
                          "update:val": function ($event) {
                            return _vm.$set(_vm.form, "customerTireSob", $event)
                          },
                        },
                      },
                      [
                        _c(
                          "div",
                          { attrs: { slot: "append" }, slot: "append" },
                          [_vm._v("%")]
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "el-col",
              { attrs: { span: 8 } },
              [
                _c(
                  "el-form-item",
                  {
                    key: "monthTireSalesAvg_" + (_vm.isBailianFlag ? "by" : ""),
                    staticClass: "form-item-title",
                    attrs: {
                      prop: "monthTireSalesAvg",
                      rules: _vm.rules.iptEmpty,
                      label: _vm.$t(
                        "retailStoresInfo.form.storeArchSit.monSalesVolume"
                      ),
                    },
                  },
                  [
                    _c("FormInputNumber", {
                      attrs: {
                        val: _vm.form.monthTireSalesAvg,
                        mode: _vm.type,
                      },
                      on: {
                        "update:val": function ($event) {
                          return _vm.$set(_vm.form, "monthTireSalesAvg", $event)
                        },
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "el-row",
          { attrs: { gutter: 60 } },
          [
            _c(
              "el-col",
              { attrs: { span: 8 } },
              [
                _c(
                  "el-form-item",
                  {
                    key: "storeStructure_" + (_vm.isBailianFlag ? "by" : ""),
                    staticClass: "form-item-title",
                    attrs: {
                      label: _vm.$t(
                        "retailStoresInfo.form.storeArchSit.retailStoreStructure"
                      ),
                      prop: "storeStructure",
                      rules: _vm.isBailianFlag ? _vm.rules.chooseEmpty : null,
                    },
                  },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: {
                          clearable: "",
                          disabled: _vm.type !== "edit",
                          placeholder: _vm.$t(
                            "retailStoresInfo.input.selectHolder"
                          ),
                        },
                        model: {
                          value: _vm.form.storeStructure,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "storeStructure", $$v)
                          },
                          expression: "form.storeStructure",
                        },
                      },
                      _vm._l(
                        _vm.lookupList["STORE_STRUCTURE"],
                        function (item, index) {
                          return _c("el-option", {
                            key: index,
                            attrs: { label: item.name, value: item.code },
                          })
                        }
                      ),
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "el-col",
              { attrs: { span: 8 } },
              [
                _c(
                  "el-form-item",
                  {
                    key: "staff_" + (_vm.isBailianFlag ? "by" : ""),
                    staticClass: "form-item-title",
                    attrs: {
                      prop: "staff",
                      rules: _vm.isBailianFlag ? _vm.rules.iptEmpty : null,
                      label: _vm.$t("retailStoresInfo.form.storeArchSit.emNum"),
                    },
                  },
                  [
                    _c("FormInputNumber", {
                      attrs: { val: _vm.form.staff, mode: _vm.type },
                      on: {
                        "update:val": function ($event) {
                          return _vm.$set(_vm.form, "staff", $event)
                        },
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "el-col",
              { attrs: { span: 8 } },
              [
                _c(
                  "el-form-item",
                  {
                    key: "retailShare_" + (_vm.isBailianFlag ? "by" : ""),
                    staticClass: "form-item-title",
                    attrs: {
                      label: _vm.$t(
                        "retailStoresInfo.form.storeArchSit.retailShare"
                      ),
                      prop: "retailShare",
                      rules: _vm.rules.iptEmpty,
                    },
                  },
                  [
                    _c(
                      "FormInputNumber",
                      {
                        attrs: {
                          val: _vm.form.retailShare,
                          max: 100,
                          step: 0.01,
                          disabled: _vm.type !== "edit",
                        },
                        on: {
                          "update:val": function ($event) {
                            return _vm.$set(_vm.form, "retailShare", $event)
                          },
                        },
                      },
                      [
                        _c(
                          "div",
                          { attrs: { slot: "append" }, slot: "append" },
                          [_vm._v("%")]
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "el-row",
          { attrs: { gutter: 60 } },
          [
            _c(
              "el-col",
              { attrs: { span: 8 } },
              [
                _c(
                  "el-form-item",
                  {
                    key: "maxSalesBrand_" + (_vm.isBailianFlag ? "by" : ""),
                    attrs: {
                      label: _vm.$t(
                        "retailStoresInfo.form.storeArchSit.maxSalesBrand"
                      ),
                      prop: "maxSalesBrand",
                      rules: _vm.rules.iptEmpty,
                    },
                  },
                  [
                    _c("FormSelect", {
                      attrs: {
                        val: _vm.form.maxSalesBrand,
                        options: _vm.lookupList["STORE_SIGN_BRAND_TYPE"],
                        disabled: _vm.type !== "edit",
                      },
                      on: {
                        "update:val": function ($event) {
                          return _vm.$set(_vm.form, "maxSalesBrand", $event)
                        },
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "el-col",
              { attrs: { span: 8 } },
              [
                _c(
                  "el-form-item",
                  {
                    key: "maxSalesQty_" + (_vm.isBailianFlag ? "by" : ""),
                    attrs: {
                      label: _vm.$t(
                        "retailStoresInfo.form.storeArchSit.maxSalesQty"
                      ),
                      prop: "maxSalesQty",
                      rules: _vm.rules.iptEmpty,
                    },
                  },
                  [
                    _c("FormInputNumber", {
                      attrs: {
                        max: 9999999,
                        val: _vm.form.maxSalesQty,
                        disabled: _vm.type !== "edit",
                      },
                      on: {
                        "update:val": function ($event) {
                          return _vm.$set(_vm.form, "maxSalesQty", $event)
                        },
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "el-col",
              { attrs: { span: 8 } },
              [
                _c(
                  "el-form-item",
                  {
                    key: "gySalesQty_" + (_vm.isBailianFlag ? "by" : ""),
                    attrs: {
                      label: _vm.$t(
                        "retailStoresInfo.form.storeArchSit.gySalesQty"
                      ),
                      prop: "gySalesQty",
                      rules: _vm.rules.iptEmpty,
                    },
                  },
                  [
                    _c("FormInputNumber", {
                      attrs: {
                        max: 9999999,
                        val: _vm.form.gySalesQty,
                        disabled: _vm.type !== "edit",
                      },
                      on: {
                        "update:val": function ($event) {
                          return _vm.$set(_vm.form, "gySalesQty", $event)
                        },
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }